<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { usePostHog } from '@/composables/usePostHog';

@Component
export default class InfraLayerFooter extends Vue {
  @Prop({ required: true }) private nextRoute!: string;
  @Prop({ required: true }) private nextLabel!: string;
  @Prop({ default: 'mdi-arrow-right' }) private icon!: string;

  private posthog = usePostHog().posthog;

  private navigate() {
    this.posthog.capture('infra_footer_clicked', { target_route: this.nextRoute, label: this.nextLabel });
    this.$emit('navigate', this.nextRoute);
  }
}
</script>

<template>
  <footer class="layer-footer">
    <button @click="navigate" class="next-layer-btn">
      <span v-if="icon.startsWith('mdi-home')" :class="['mdi', icon]"></span>
      <span>{{ nextLabel }}</span>
      <span v-if="!icon.startsWith('mdi-home')" :class="['mdi', icon]"></span>
    </button>
  </footer>
</template>

<style scoped>
.layer-footer {
  margin-top: 6rem;
  display: flex;
  justify-content: center;
}

.next-layer-btn {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem 3rem;
  background: var(--ln-glass-elevated);
  border: 1px solid var(--ln-glass-border-strong);
  border-radius: var(--ln-radius-xl);
  font-weight: 700;
  color: var(--ln-text-primary);
  transition: all var(--ln-transition-normal) var(--ln-ease-bounce);
  text-decoration: none;
  cursor: pointer;
  font-size: 1rem;
}

.next-layer-btn:hover {
  background: var(--ln-teal-deep);
  color: white !important;
  transform: translateX(10px);
}

@media (max-width: 768px) {
  .layer-footer {
    margin-top: 3rem;
  }
  
  .next-layer-btn {
    padding: 1.2rem 2rem;
    width: 100%;
    justify-content: center;
    font-size: 0.9rem;
  }
}
</style>
